import { render, staticRenderFns } from "./TransferDetailOptions.vue?vue&type=template&id=3abe3ed5&"
import script from "./TransferDetailOptions.vue?vue&type=script&lang=js&"
export * from "./TransferDetailOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports